<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-11 col-sm-11 col-md-11 col-lg-11">
          <ul class="breadcrumb breadcrumb-style">
            <li class="breadcrumb-item">
              <h4 class="page-title">
                {{GetRole(userAccount.UserRoleId)}} Profile
              </h4>
            </li>
            <li
              *ngIf="userAccount.UserRoleId == 3 ||userAccount.UserRoleId == 4"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/pharmacist/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li
              *ngIf="userAccount.UserRoleId == 2"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/doctor/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li class="breadcrumb-item active bcrumb-2">
              {{GetRole(userAccount.UserRoleId)}}
            </li>
            <li class="breadcrumb-item active">Profile</li>
          </ul>
        </div>
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
          <a
            type="button"
            (click)="this.goBack()"
            class="btn btn-group-lg btn-outline-secondary float-end back-btn-width"
          >
            <i class="fa fa-angle-left"></i> Back
          </a>
        </div>
      </div>
    </div>
    <!-- Your content goes here  -->
    <div class="row clearfix">
      <div class="col-lg-4 col-md-12">
        <div class="card">
          <div class="m-b-20">
            <div class="contact-grid">
              <div class="profile-header bg-dark">
                <button
                  mat-icon-button
                  color="accent"
                  class="btn-tbl-edit align-top float-end btn-outline-dark"
                  (click)="$event.stopPropagation()"
                  [routerLink]="['/doctor/profile/edit']"
                  routerLinkActive="router-link-active"
                  *ngIf="userAccount.UserRoleId == loginUser.UserRoleId"
                >
                  <mat-icon aria-label="Edit" class="col-white">edit</mat-icon>
                </button>
                <div *ngIf="this.userAccount.UserRoleId == 2" class="user-name">
                  {{ doctorDetails.doctor.PracticeName }}
                  <!-- <button
                    mat-icon-button
                    color="accent"
                    class="btn-tbl-edit align-top float-end"
                    (click)="$event.stopPropagation()"
                  >
                    <mat-icon aria-label="Edit" class="col-white"
                      >edit</mat-icon
                    >
                  </button> -->
                </div>
                <div class="name-center text-capitalize p-t-20">
                  <h6>
                    {{userAccount.UserRoleId==2?'Dr. ':''}} {{
                    userAccount?.FirstName }} {{ userAccount?.LastName }}
                  </h6>
                  <br />
                </div>
              </div>
              <!-- <img src="{{ user.profilePicture }}" class="user-img" alt="" /> -->
              <img
                *ngIf="userAccount.ProfilePictureId==0 && userAccount.UserRoleId == 2"
                alt="User Image"
                class="user-img"
                height="100"
                src="assets/images/user/dr.png"
              />
              <img
                *ngIf="userAccount.ProfilePictureId==0 && userAccount.UserRoleId == 2"
                alt="User Image"
                class="user-img"
                src="assets/images/user/dr.png"
                height="100"
              />
              <img
                #profilePic
                class="user-img"
                [src]="imgSrc"
                alt="User Image"
                height="100"
              />
              <p>
              </p>
              <div>
                <span class="phone p-3">
                </span>
              </div>
              <div class="row">
                <div class="col-7">
                  <a
                    *ngIf="this.loginUser.Id != this.userAccount.Id"
                    [href]="mailto"
                  >
                    <h6>{{ userAccount.Email }}</h6></a
                  >

                  <h6 *ngIf="this.loginUser.Id == this.userAccount.Id">
                    {{ userAccount.Email }}
                  </h6>
                  <small>Email</small>
                </div>
                <div class="col-5">
                  <h6>{{ userAccount.Phone }}</h6>

                  <small>Phone</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="doctorDetails.doctor.IsApproved == 'PENDING'">
          <div class="row pb">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <button class="btn btn-primary w-100" (click)="approveDoctor()">
                Approve
              </button>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <button class="btn btn-danger w-100" (click)="rejectDoctor()">
                Reject
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-md-12">
        <div class="card">
          <mat-tab-group>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon msr-2">face</mat-icon>
                Personal Information
              </ng-template>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="project_widget">
                  <div class="body p-0">
                    <div class="row m-0">
                      <div class="col-lg-6 col-md-6 col-sm-6 mb-0">
                        <div class="project_widget">
                          <div class="header">
                            <h2>
                              <strong>Gender</strong>
                            </h2>
                          </div>
                          <div class="body pt-0 pb-0">
                            {{ userAccount?.Gender !=null &&
                            userAccount?.Gender!=''?(userAccount?.Gender ==
                            'M'?'Male':'Female'):'-' }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 mb-0">
                        <div class="project_widget">
                          <div class="header">
                            <h2>
                              <strong>DOB</strong>
                            </h2>
                          </div>
                          <div class="body pt-0 pb-0">
                            {{
                            userAccount.DateOfBirth!=null?(userAccount.DateOfBirth
                            | date:'MM/dd/yyyy'):'-' }}
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="this.userAccount.UserRoleId == 2"
                        class="col-lg-6 col-md-6 col-sm-6 mb-0"
                      >
                        <div class="project_widget">
                          <div class="header">
                            <h2>
                              <strong>Registration Number</strong>
                            </h2>
                          </div>
                          <div class="body pt-0 pb-0">
                            {{ doctorDetails?.doctor?.RegistrationNumber ==
                            null?'-':doctorDetails?.doctor?.RegistrationNumber
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="this.userAccount.UserRoleId == 2"
                        class="col-lg-6 col-md-6 col-sm-6 mb-0"
                      >
                        <div class="project_widget">
                          <div class="header">
                            <h2>
                              <strong>Registration Certificate</strong>
                            </h2>
                          </div>
                          <div class="body pt-0 pb-0">
                            <p class="text-muted d-inline-flex mb-0">
                              <a
                                style="cursor: pointer; display: inline-flex;"
                                (click)="DownloadDoctorDocument(doctorDetails?.RegistrationFiles?.DocumentId)"
                                title="Click to download registration certificate"
                                class="doc-card-title pointer"
                              >
                                <i class="material-icons">attachment</i>&nbsp;
                                <span>
                                  {{
                                  doctorDetails?.RegistrationFiles?.DocumentName
                                  ==
                                  null?'-':doctorDetails?.RegistrationFiles?.DocumentName
                                  }}
                                </span>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="this.userAccount.UserRoleId == 2"
                        class="col-lg-6 col-md-6 col-sm-6 mb-0"
                      >
                        <div class="project_widget">
                          <div class="header">
                            <h2>
                              <strong>Qualification</strong>
                            </h2>
                          </div>
                          <div class="body pt-0">
                            {{ doctorDetails?.doctor?.Qualification == null?'-':
                            doctorDetails?.doctor?.Qualification}}
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="this.userAccount.UserRoleId == 2"
                        class="col-lg-6 col-md-6 col-sm-6 mb-0"
                      >
                        <div class="project_widget">
                          <div class="header">
                            <h2>
                              <strong>Specialization</strong>
                            </h2>
                          </div>
                          <div class="body pt-0">
                            <p>
                              {{ doctorDetails?.doctor?.Specialization ==
                              null?'-':doctorDetails?.doctor?.Specialization }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="this.userAccount.UserRoleId == 2"
                        class="col-lg-6 col-md-6 col-sm-6 mb-0"
                      >
                        <div class="project_widget">
                          <div class="header">
                            <h2>
                              <strong>Office Contact Name</strong>
                            </h2>
                          </div>
                          <div class="body pt-0">
                            {{ doctorDetails?.doctor?.OfficeContactName=='' ||
                            doctorDetails?.doctor?.OfficeContactName ==
                            null?'-':doctorDetails?.doctor?.OfficeContactName }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 mb-0">
                        <div class="project_widget">
                          <div class="header">
                            <h2>
                              <strong>Address</strong>
                            </h2>
                          </div>
                          <div class="body pt-0">
                            <p>
                              {{address == ''?'-':address}}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        *ngIf="this.userAccount.UserRoleId == 2"
                        class="col-lg-12 col-md-12 col-sm-12"
                      >
                        <div class="project_widget">
                          <div class="header">
                            <h2>
                              <strong>About Me</strong>
                            </h2>
                          </div>
                          <div class="body pt-0">
                            <p>
                              {{ doctorDetails?.doctor?.AboutMe == null ||
                              doctorDetails?.doctor?.AboutMe == '' ?
                              '-':doctorDetails?.doctor?.AboutMe }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

        <div class="card" *ngIf="this.currentUser.UserRoleId != 2">
          <mat-tab-group>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon msr-2">dashboard</mat-icon>
                Collection Location
              </ng-template>
              <div clas="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="project_widget">
                    <div class="p-0">
                      <div class="row m-0">
                        <div class="col-lg-12 col-md-12 col-sm-12 mb-0">
                          <div class="project_widget">
                            <div class="header">
                            </div>
                            <div id="tag-list-wrapper" class="add-tag-wrapper mt-3">
                              <mat-chip-list>
                                  <mat-chip *ngFor="let collectionLocationlist of collectionLocation;let i = index">{{collectionLocationlist}}
                                </mat-chip>
                              </mat-chip-list>
                            </div>

                            <!-- <div class="body pt-0 pb-0">
                              {{ collectionLocation }}
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 mb-0">
                  <div class="project_widget">
                    <div class="header">
                      <h2></h2>
                    </div>
                    <div class="body pt-0">
                      <p>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #ApproveDoctorComponent>
  <div class="row delete-confirm">
    <div class="col-sm-12 mb-3">
      Are you sure you want to approve doctor <br />
      <span class="text-info"
        >{{ doctorDetails?.userAccount.FirstName }}&nbsp;{{
        doctorDetails?.userAccount.LastName }}</span
      >&nbsp;?
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-5">
          <button
            type="button"
            (click)="ApproveDoctor()"
            class="btn btn-sm btn-primary me-3"
          >
            Yes
          </button>

          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
